import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";

const CookiePolicy = () => {
  const { language, setLanguage, content } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <Header
        language={language}
        onLanguageChange={setLanguage}
        content={content.header}
      />
      
      <main className="pt-20">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-8 hero-text">Cookie Policy</h1>
            
            <div className="prose prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-semibold mb-4">Vad är cookies?</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Cookies är små textfiler som lagras på din enhet när du besöker vår webbplats. 
                  De hjälper oss att förbättra din användarupplevelse och analysera hur vår webbplats används.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Hur använder vi cookies?</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Volym Digitalbyrå AB använder cookies för följande ändamål:
                </p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                  <li>Nödvändiga cookies: För att webbplatsen ska fungera korrekt</li>
                  <li>Analytiska cookies: För att förstå hur besökare använder vår webbplats</li>
                  <li>Funktionella cookies: För att komma ihåg dina preferenser som språkval</li>
                  <li>Marknadsföringscookies: För att visa relevant innehåll och annonser</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Vilka cookies använder vi?</h2>
                <div className="space-y-4">
                  <div className="border-l-4 border-primary pl-4">
                    <h3 className="font-semibold">Nödvändiga cookies</h3>
                    <p className="text-muted-foreground">
                      Dessa cookies är nödvändiga för att webbplatsen ska fungera och kan inte stängas av.
                    </p>
                  </div>
                  
                  <div className="border-l-4 border-primary pl-4">
                    <h3 className="font-semibold">Google Analytics</h3>
                    <p className="text-muted-foreground">
                      Vi använder Google Analytics för att analysera trafik och förbättra vår webbplats.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Hantera cookies</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Du kan när som helst ändra dina cookie-inställningar i din webbläsare. 
                  Observera att om du blockerar vissa cookies kan det påverka funktionaliteten på vår webbplats.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Kontakta oss</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Om du har frågor om vår cookie policy, kontakta oss på:
                </p>
                <div className="mt-4 p-4 bg-muted rounded-lg">
                  <p><strong>Volym Digitalbyrå AB</strong></p>
                  <p>E-post: info@volymkommunikation.se</p>
                  <p>Telefon: +46 10 750 28 66</p>
                </div>
              </section>

              <section>
                <p className="text-sm text-muted-foreground">
                  Senast uppdaterad: {new Date().toLocaleDateString('sv-SE')}
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer content={content.footer} />
    </div>
  );
};

export default CookiePolicy;